module.exports = __webpack_public_path__ + "img/Discover.87dc5055.jpg";